import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from '@mui/material';

const ConfirmationDialog = ({ isOpen, onClose, onConfirm,title='Confirm Deletion', message }) => {
  const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      // fullScreen={fullScreen}
      maxWidth="xs"
      fullWidth
      sx={{padding: 2, '& .MuiDialog-paper': { padding: 2 }}}
    >
      <DialogTitle sx={{ fontSize: '1.25rem' }}>{title}</DialogTitle>

      <DialogContent>
        {typeof message === 'string' ? (
          <Typography variant="body1">{message}</Typography>
        ) : (
          <Box>{message}</Box>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          sx={{ px: 4 }}
        >
          Yes
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          sx={{ px: 4 }}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default ConfirmationDialog;
